import { getRegionNames } from '@/metrics/helpers/helpers'

import { emptyValue, negativeMarginSkusCaptions } from './constants'

export const formatNumbersAmount = (amount, currency, language) => {
  return new Intl.NumberFormat(language, { style: 'currency', currency }).format(Number(amount))
}

export const formatNumbersWholeAmount = (amount, currency, language) => {
  return new Intl.NumberFormat(language, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(Number(amount))
}

export const formatNumbersPercentage = (percentage, language) => {
  return new Intl.NumberFormat(language, {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(percentage / 100)
}

export const formatNumbersCount = (count, language) => {
  if (count === null) return emptyValue

  return new Intl.NumberFormat(language).format(count)
}

const getNoDataKpi = t => ({ value: emptyValue, caption: t('Sin datos') })

export const getOrdersKpi = (numbers, t, language) => {
  if (numbers.orders_count === null) return getNoDataKpi(t)

  return {
    value: formatNumbersCount(numbers.orders_count, language),
    caption: t('Excluyendo pedidos borrador'),
  }
}

export const getAverageOrderValueKpi = (numbers, t, language) => {
  if (numbers.average_order_value === null) return getNoDataKpi(t)

  return {
    value: formatNumbersAmount(numbers.average_order_value, numbers.currency, language),
    caption: t('por pedido'),
  }
}

export const getOrderReturnRateKpi = (numbers, t, language) => {
  if (numbers.returned_orders_percentage === null) return getNoDataKpi(t)

  const value = formatNumbersPercentage(numbers.returned_orders_percentage, language)

  if (numbers.returned_orders_count === null) return { value, caption: t('Sin datos') }

  return {
    value,
    caption: t('{{returned}} de {{total}} pedidos', {
      returned: formatNumbersCount(numbers.returned_orders_count, language),
      total: formatNumbersCount(numbers.orders_count, language),
    }),
  }
}

export const getEarningsRetainedKpi = (numbers, t, language) => {
  if (numbers.earnings_retained === null) return getNoDataKpi(t)

  return {
    value: formatNumbersAmount(numbers.earnings_retained, numbers.currency, language),
    caption: t('Saldo de tienda + cambios'),
  }
}

export const getMarketsTeaser = (numbers, t, language) => {
  if (numbers.lowest_margin_market === null) return getNoDataKpi(t)

  return {
    value: formatNumbersPercentage(numbers.lowest_margin_market.margin_percentage, language),
    caption: t('{{country}}, tu mercado con menos margen', {
      country: getRegionNames(language).of(numbers.lowest_margin_market.country_code),
    }),
  }
}

export const getProductsTeaser = (numbers, t, language) => {
  if (numbers.negative_margin_skus_count === null) return getNoDataKpi(t)

  const caption =
    numbers.negative_margin_skus_count === 0 ? negativeMarginSkusCaptions.none : negativeMarginSkusCaptions.some

  return {
    value: t('{{count}} SKUs', { count: formatNumbersCount(numbers.negative_margin_skus_count, language) }),
    caption: t(caption),
  }
}

export const getLogisticsTeaser = (numbers, t, language) => {
  if (numbers.free_shipping_covered_amount === null) return getNoDataKpi(t)

  return {
    value: formatNumbersWholeAmount(numbers.free_shipping_covered_amount, numbers.currency, language),
    caption: t('envío gratis que cubres ({{percentage}})', {
      percentage: formatNumbersPercentage(numbers.free_shipping_covered_percentage, language),
    }),
  }
}
